module.exports = ":host /deep/ .tooltip {\n  display: block;\n  background: black;\n  color: white;\n  padding: 0.7em; }\n"